'use strict';

Object.defineProperty(exports, "__esModule", {
  value: true
});

var _react = require('react');

var _react2 = _interopRequireDefault(_react);

var _reactCssModules = require('react-css-modules');

var _reactCssModules2 = _interopRequireDefault(_reactCssModules);

var _styles = require('./styles.scss');

var _styles2 = _interopRequireDefault(_styles);

var _FormInput = require('../../../FormInput');

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var renderOptions = function renderOptions() {
  return _react2.default.createElement('span', null);
};

var getTitle = function getTitle(type) {
  return type === 'shipping' ? 'Shipping Address' : 'Billing Address';
};
var renderTitle = function renderTitle(type) {
  return _react2.default.createElement(
    'h1',
    null,
    getTitle(type)
  );
};

var getPrefix = function getPrefix(type) {
  return type === 'shipping' ? 'ship' : 'bill';
};

var renderFormFields = function renderFormFields(props) {
  var prefix = getPrefix(props.type);
  return _react2.default.createElement(
    'div',
    null,
    _react2.default.createElement(_FormInput.Input, {
      id: prefix + 'AddressCompanyname',
      name: 'order[' + prefix + '_address_attributes][company]',
      defaultValue: props.company,
      type: 'hidden'
    }),
    _react2.default.createElement(_FormInput.Input, {
      id: prefix + 'AddressFirstname',
      name: 'order[' + prefix + '_address_attributes][firstname]',
      defaultValue: props.firstName,
      type: 'hidden'
    }),
    _react2.default.createElement(_FormInput.Input, {
      id: prefix + 'AddressFirstname',
      name: 'order[' + prefix + '_address_attributes][lastname]',
      defaultValue: props.lastName,
      type: 'hidden'
    }),
    _react2.default.createElement(_FormInput.Input, {
      id: prefix + 'AddressAddress1',
      name: 'order[' + prefix + '_address_attributes][address1]',
      defaultValue: props.address1,
      type: 'hidden'
    }),
    _react2.default.createElement(_FormInput.Input, {
      id: prefix + 'AddressAddress2',
      name: 'order[' + prefix + '_address_attributes][address2]',
      defaultValue: props.address2,
      type: 'hidden'
    }),
    _react2.default.createElement(_FormInput.Input, {
      id: prefix + 'AddressCity',
      name: 'order[' + prefix + '_address_attributes][city]',
      defaultValue: props.city,
      type: 'hidden'
    }),
    _react2.default.createElement(_FormInput.Input, {
      id: prefix + 'AddressZipcode',
      name: 'order[' + prefix + '_address_attributes][zipcode]',
      defaultValue: props.postcode,
      type: 'hidden'
    }),
    _react2.default.createElement(_FormInput.Input, {
      id: prefix + 'AddressStateName',
      name: 'order[' + prefix + '_address_attributes][state_name]',
      defaultValue: props.stateName,
      type: 'hidden'
    }),
    _react2.default.createElement(_FormInput.Input, {
      id: prefix + 'AddressPhone',
      name: 'order[' + prefix + '_address_attributes][phone]',
      defaultValue: props.phone,
      type: 'hidden'
    })
  );
};

exports.default = (0, _reactCssModules2.default)(_styles2.default)(function (props) {
  return _react2.default.createElement(
    'div',
    { styleName: 'address' },
    renderTitle(props.type),
    renderOptions(props.type),
    _react2.default.createElement(
      'ul',
      null,
      _react2.default.createElement(
        'li',
        null,
        props.firstName,
        ' ',
        props.lastName
      ),
      _react2.default.createElement(
        'li',
        null,
        props.company
      ),
      _react2.default.createElement(
        'li',
        null,
        props.address1
      ),
      _react2.default.createElement(
        'li',
        null,
        props.address2
      ),
      _react2.default.createElement(
        'li',
        null,
        props.city
      ),
      _react2.default.createElement(
        'li',
        null,
        props.state
      ),
      _react2.default.createElement(
        'li',
        null,
        props.postcode
      ),
      _react2.default.createElement(
        'li',
        null,
        props.phone
      )
    ),
    renderFormFields(props),
    _react2.default.createElement(
      'a',
      { href: '', onClick: props.onChooseAddress(props.type) },
      'Choose a different address'
    )
  );
});
module.exports = exports['default'];


//////////////////
// WEBPACK FOOTER
// ./shared/components/AddressBook/components/SelectedAddress/index.js
// module id = 2259
// module chunks = 0